import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from '@/store'
import { CommonServices } from '@/services/CommonServices'
import { StorageServices } from '@/services/StorageServices'
import begin from '@/views/begin';
import home from '@/views/home';
import appuntamenti from '@/views/appuntamenti';
import profilo from '@/views/profilo';
import notifiche from '@/views/notifiche';
import faq from '@/views/faq';
import imieipacchetti from '@/views/imieipacchetti';
import supportMeeting from '@/views/supportMeeting';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/maintenance',
        name: 'maintenance',
        component: () => import("../views/maintenance/Maintenance.vue"),
    },
    ...begin.routes(),
    {
        path: '/',
        component: () => import("../views/layout/layout.vue"),
        children: [
            ...home.routes(),
            ...appuntamenti.routes(),
            ...profilo.routes(),
            ...notifiche.routes(),
            ...imieipacchetti.routes(),
            ...faq.routes(),
            ...supportMeeting.routes()
        ]
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior: (to, from, savedPosition) => {
        window.scrollTo(savedPosition ? savedPosition.left : 0, savedPosition ? savedPosition.top : 0);
    }
})


// Routes that an anonymous (not logged in) user is allowed to reach.
// Everything else lives under the authenticated `layout` subtree and requires a valid session.
const publicRouteNames = [
    'maintenance',
    'login',
    'family_invitation',
    'confirm_email',
    'register',
    'bookingpromo',
    'registrati',
    'reset_password',
    'change_password',
];

function isAuthenticated(): boolean {
    // Rely on the persisted session in localStorage as source of truth: on a
    // deep-link / page reload the router guard can run before App.vue's async
    // bootstrap repopulates store.state.user, so checking only the in-memory
    // user would wrongly bounce a logged-in user to login.
    if (CommonServices.getAuthToken()) {
        const persistedUser = StorageServices.getLoggedUser();
        if (persistedUser && persistedUser.token)
            return true;
    }
    return !!(store.state.user && store.state.user.token);
}

router.beforeEach((to, from, next) => {
    if (store.state.maintenance && to.name !== 'maintenance') {
        next('/maintenance');
        return;
    }

    // Guard the authenticated area: anonymous users hitting a private route
    // (e.g. /appuntamenti) are sent to login instead of into the layout, which
    // would otherwise fire authenticated API calls that 401 and surface a
    // dead-end "Errore" modal with no way back to login.
    const isPublicRoute = publicRouteNames.indexOf(to.name as string) !== -1;
    if (!isPublicRoute && !isAuthenticated()) {
        next({ path: '/', query: { redirect: to.fullPath } });
        store.state.beforeNavCbs = [];
        return;
    }

    const userRole = store.state.user && store.state.user.role
        ? store.state.user.role.toString().toLowerCase()
        : '';
    const isFamilyUser = userRole.indexOf('family') !== -1;
    const restrictedForFamily = ['/academy', '/webinar'];

    if (isFamilyUser && restrictedForFamily.some(prefix => to.path.startsWith(prefix))) {
        next('/atupertu');
        store.state.beforeNavCbs = [];
        return;
    }

    if(store.state.beforeNavCbs.length == 0){
        next();
        return;
    }
    store.state.beforeNavCbs.forEach(x => {
        x(to, from, next);
    });
    store.state.beforeNavCbs = [];
})

router.afterEach((to, from) => {
    store.state.afterNavCbs.forEach(x => {
        x(to, from);
    });
    store.state.afterNavCbs = [];
})

export default router
